import { useState, useContext } from "react";
import { useTranslation } from "react-i18next";
import unlockPhase from "../../../../../assets/unlock-phase.jpg";
import Button from "../../../../../components/button";
import {
  ButtonSize,
  ButtonVariant,
} from "../../../../../components/button/types";
import { useContentAndProgress } from "../../../../../contexts/UserProgressContext";
import "react-datepicker/dist/react-datepicker.css";
import { AuthContext } from "../../../../../contexts/AuthContext";
import UnlockPhaseModal from "./UnlockPhaseModal";

export function UnlockPhase() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { t } = useTranslation("unlock");
  const { activePhase, phases } = useContentAndProgress();
  const { user } = useContext(AuthContext);
  const journeyId = user?.userDetails.journeyId;

  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);

  const listItems: string[] = t("list", { returnObjects: true }) as string[];


  const lastPhase = phases?.[phases.length - 1];
  const phaseNumber =
  (lastPhase?.content?.orderForProgress[journeyId ?? ""] || 0) + 1;

  const buttonTitle = t("button.title").replace(
    "{phaseNumber}",
    phaseNumber.toString()
  );
  const title = t("title").replace("{phaseNumber}", phaseNumber.toString());
  return (
    <div className="font-sans">
      <img src={unlockPhase} alt="Unlock Phase" className="w-full mb-6" />
      <h1 className="text-2xl font-bold mb-3 text-left">{title}</h1>
      <div className="mb-4">{t("paragraph1")}</div>
      <div className="mb-4">{t("paragraph2")}</div>
      <div className="flex justify-center mt-8">
        <Button
          variant={ButtonVariant.PRIMARY}
          size={ButtonSize.SMALL}
          onClick={handleOpenModal}
        >
          {buttonTitle}
        </Button>
      </div>

      {/* Popup Modal */}
      <UnlockPhaseModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        activePhase={activePhase}
      />
    </div>
  );
}

export default UnlockPhase;
